import { Injectable } from '@angular/core';

import { ObjectCheckerService } from '../../../../../services/object-checker.service';
import { CollisionService } from '../../../../../services/collision/collision.service';
import { DragHandlerBase } from '../../Handler/drag-handler-base';
import { DragBehaviorBase } from '../drag-behavior-base';
import { AwningService } from '../../../../../services/awning/awning.service';
import { HelperLinesService } from '../../../../../services/helper-lines.service';

declare const THREE: any;

class AwningDrag extends DragBehaviorBase {
  protected wall;
  protected dragPlane: any;
  protected clickPoint: any;
  objectsOffset: object = {};

  constructor(
    handler,
    private objectCheckerSrvc: ObjectCheckerService,
    private collisionSrvc: CollisionService,
    private awningService: AwningService
  ) {
    super(handler);
    this.dragPlane = new THREE.Plane();
    this.clickPoint = new THREE.Vector3();
  }

  hold(e) {
    const { point, object } = e.intersection;
    const normal = new THREE.Vector3();
    object.getWorldDirection(normal);
    this.dragPlane.setFromNormalAndCoplanarPoint(normal, point);
    this.clickPoint.copy(point);
    super.hold(e);
  }

  canExecute(selected) {
    // Only real awnings: other wall-mountables (e.g. Trellis) have no awning
    // grouping and are handled by WallMountedObjectDrag.
    return selected.every(obj => this.objectCheckerSrvc.isAwning(obj));
  }

  move(e, transformation) {
    this.wall = e.draggedObject.parent;
    const { draggedObject, raycaster, draggedObjectWorldTransform, staticObjects } = e;
    const newSize = this.awningService.getSizes(draggedObject);
    const draggedObjectId = draggedObject.id;
    const objectsOffset = this.objectsOffset;
    const filteredStaticObjects = staticObjects.filter(
      so => !this.awningService.isFromTheSameGroup(draggedObject, so)
    );

    raycaster.ray.intersectPlane(this.dragPlane, transformation.position);

    objectsOffset[draggedObjectId] =
      objectsOffset[draggedObjectId] ||
      this.clickPoint.clone().sub(draggedObjectWorldTransform.position);

    transformation.position.sub(objectsOffset[draggedObjectId]);

    super.move(e, transformation);

    const newPosition = this.awningService.getGroupCenterFromFuturePosition(
      draggedObject,
      transformation.position
    );

    // HelperLinesService.buildOneTestLineAndUpdate(newPosition, 0, `newBaseCenterPosition`);

    const collided = this.collisionSrvc.isCollide(draggedObject, filteredStaticObjects, {
      newPosition,
      newSize
    });

    if (collided) {
      transformation.position.copy(draggedObjectWorldTransform.position);
    }
  }

  release(e) {
    this.objectsOffset = {};
    super.release(e);
  }

  getStaticObjectsFilter(objects) {
    const baseFilter = super.getStaticObjectsFilter(objects);
    return obj => baseFilter(obj) && this.objectCheckerSrvc.isWallMountable(obj);
  }
}

@Injectable()
export class AwningDragFactory {
  constructor(
    private objectCheckerSrvc: ObjectCheckerService,
    private collisionSrvc: CollisionService,
    private awningService: AwningService
  ) {}

  create(nextHandler?: DragHandlerBase) {
    return new AwningDrag(
      nextHandler,
      this.objectCheckerSrvc,
      this.collisionSrvc,
      this.awningService
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Behavior/WallObject/awning-drag.ts